import React from 'react'
import { Crumb } from './Crumb'
import { StyledBreadcrumbs } from './styled'

export const DefaultBreadcrumbs = () => (
  <StyledBreadcrumbs>
    <Crumb
      item={{
        text: 'Graphics',
        accentedText: 'Portal',
        linkTo: '/',
        theme: 'portal',
        autoClassName: 'auto-portal-crumb',
      }}
      isLast
    />
  </StyledBreadcrumbs>
)
